import { API } from '@/api';
import axios from 'axios';

const state = {
  condo: null,
};
const getters = {
  getCondo: (State) => {
    if (state.condo !== null) {
      return state.condo;
    } else if (typeof window.sessionStorage.getItem('condominio') === 'string') {
      state.condo = JSON.parse(window.sessionStorage.getItem('condominio') || 'null');
      return state.condo;
    } else {
      console.error('Error parsing window.sessionStorage.getItem("condominio")');
      return null;
    }
  },
};
const actions = {
  async getCondoList({ commit, State }, {id, options}) {
    console.debug('ID: %o', id);
    const sortBy = options.sortBy[0] ? options.sortBy[0] + ',' + (options.sortDesc[0] ? 'desc' : 'asc') : '';
    const queryString = {page: options.page - 1, size: options.itemsPerPage, sort: sortBy};
    console.debug('queryString: %o', queryString);
    const response = await API.get(`/${id}/condominios/list/` , {params: queryString});
    return response.data;
  },
  async getCondoById({ commit, State }, {admin, condo}) {
    const response = await API.get(`/${admin.id}/condominios/${condo.id}`);
    return response.data;
  },
  async addCondo({ commit, State }, {admin, condo}) {
    const response = await API.post(`/${admin.id}/condominios/add/`, condo);
    return response.data;
  },
  async addLoteAvisos({ commit, State }, {admin, condo, avisos}) {
    const response = await API.post('/recordatorios/crear/unidad/' + admin.id + '/' + condo.id, avisos);
    return response.data;
  },
  // Modificar
  async updateCondo({ commit, State }, {admin, condo}) {
    const response = await API.post(`/${admin.id}/condominios/modify/`, condo);
    return response.data;
  },
  //
  async getProps({ commit, State }, {admin, condo}) {
    const response = await API.get(`/${admin.id}/${condo.id}/condominios/props/`);
    return response.data;
  },
  async addProps({ commit, State }, {admin, condo, prop}) {
    const response = await API.post(`/${admin.id}/${condo.id}/condominios/props/`, prop);
    return response.data;
  },
  async updateProps({ commit, State }, {admin, condo, prop}) {
    const response = await API.put(`/${admin.id}/${condo.id}/condominios/props/`, prop);
    return response.data;
  },
  async deleteProps({ commit, State }, {admin, condo, name}) {
    const response = await API.delete(`/${admin.id}/${condo.id}/condominios/props/${name}`);
    return response.data;
  },
  //
  async deleteCondo({ commit, State }, {admin, condo}) {
    const response = await API.delete(`/${admin.id}/condominios/delete/`, condo);
    return response;
  },
  setCondo({ commit, State }, condo) {
     commit('setCondo', condo);
  },
  clearCondo({ commit, State }) {
    commit('clearCondo');
  },
};
const mutations = {
  setCondo: (State, condo) => {
    console.debug('condo: %o', condo);
    State.condo = condo;
    window.sessionStorage.setItem('condominio', JSON.stringify(condo));
  },
  clearCondo: (State) => {
    State.condo = null;
    window.sessionStorage.removeItem('condominio');
  },
};

export default {
  actions,
  getters,
  mutations,
  state,
};
